import { objectKeys } from '../languageExtensions/object.js';
import { isNullish } from './nullish.js';

const appendErrorMessage = (originalErrorMessages, newErrorMessage) => {
  if (!originalErrorMessages) return newErrorMessage;
  if (!newErrorMessage) return originalErrorMessages;
  return `${originalErrorMessages}, ${newErrorMessage}`;
};
/**
 * Provided an object to validate, and a validation object, checks for required
 * keys if their validation object value is `true`, otherwise checks
 * if they meet the criteria of the passed validator function
 */

const getKeyValidationErrors = (item, validationKeys) => {
  const errors = objectKeys(validationKeys).reduce((errorMessagesOrNull, key) => {
    let value = undefined;

    if (Object.prototype.hasOwnProperty.call(item, key)) {
      value = item[key];
    }

    const validator = validationKeys[key];
    if (!validator) return errorMessagesOrNull; // Validator functions return string (errors) or null (no errors)

    if (typeof validator === 'function') {
      const errorsFromValidator = validator(value, item);
      if (errorsFromValidator) return appendErrorMessage(errorMessagesOrNull, `${String(key)} failed validation: ${errorsFromValidator}`);
      return errorMessagesOrNull;
    } // Boolean validators only check for the existence of a required key.


    if (isNullish(value)) return appendErrorMessage(errorMessagesOrNull, `${String(key)} is required`);
    return errorMessagesOrNull;
  }, null);
  return errors;
};

export { appendErrorMessage, getKeyValidationErrors };
